// pkce.ts

/**
 * Membuat code_verifier acak dengan karakter A-Z, a-z, 0-9, serta `-._~`
 * Sesuai spesifikasi RFC 7636 (panjang antara 43 - 128 karakter).
 */
export function generateCodeVerifier(length: number = 64): string {
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  const randomValues = new Uint8Array(length);
  window.crypto.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map((val) => possible[val % possible.length])
    .join("");
}

/**
 * Membuat code_challenge berbasis SHA-256 (S256) dari code_verifier.
 */
export async function generateCodeChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);

  return base64UrlEncode(digest);
}

/**
 * Helper untuk konversi ArrayBuffer/Digest menjadi Base64URL string (RFC 4648).
 */
function base64UrlEncode(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
